import { timeEntryBilling, type TimeEntry } from '@stfors/shared-types';

// How a time entry prices on screen. Delegates to timeEntryBilling() — the
// rule the API invoices with (migration 0057) — so a table can never show a
// figure the invoice would disagree with: a flat fee counts ONCE, at the
// entry's own fee when it has one; an hourly entry is hours × rate.

/** True for a flat-fee rate, which bills once and needs no duration. */
export function isFlatRate(rate: { rate_type: string } | null | undefined): boolean {
  return rate?.rate_type === 'flat_fee';
}

/** Quantity + unit for an entry, priced at `rateAmount` (default: its stored rate). */
export function entryBilling(
  e: TimeEntry,
  rateAmount: string = e.service_rate_amount ?? '0',
): { quantity: string; unit_amount: string } {
  return timeEntryBilling(
    { rate_type: e.service_rate_type ?? 'hourly', hours: e.hours, flat_amount: e.flat_amount },
    rateAmount,
  );
}

/** Dollar value of an entry, priced at `rateAmount` (default: its stored rate). */
export function entryAmount(e: TimeEntry, rateAmount?: string): number {
  const { quantity, unit_amount } = entryBilling(e, rateAmount);
  return Number(quantity) * Number(unit_amount);
}

/** Hours for display — '—' for a flat-fee entry logged without a duration. */
export function fmtEntryHours(hours: string | null): string {
  if (hours === null) return '—';
  const n = Number(hours);
  return Number.isFinite(n) ? n.toFixed(2) : hours;
}
